import { render, staticRenderFns } from "./BaseButtonRounded.vue?vue&type=template&id=0bcc5b7a&scoped=true&"
import script from "./BaseButtonRounded.vue?vue&type=script&lang=js&"
export * from "./BaseButtonRounded.vue?vue&type=script&lang=js&"
import style0 from "./BaseButtonRounded.vue?vue&type=style&index=0&id=0bcc5b7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcc5b7a",
  null
  
)

component.options.__file = "BaseButtonRounded.vue"
export default component.exports